import * as GC from '@grapecity/spread-sheets';
import { spreadsheetConfig as defaultSpreadSheetConfig } from '@shared/spreadsheet/spreadsheet-config';

export const INVALID_PERIOD_ZERO_DATE_MESSAGE = 'Error: Invalid Period 0 Date';

// Test text and colors
// ---------------------
// FAIL
export const FAIL_TEXT = 'FAIL';
export const FAIL_COLOR = defaultSpreadSheetConfig.failBackColor;
// PASS
export const PASS_TEXT = 'PASS';
export const PASS_COLOR = defaultSpreadSheetConfig.passBackColor;
// WARNING
export const WARNING_TEXT = 'WARNING';
export const WARNING_COLOR = defaultSpreadSheetConfig.warningBackColor;
// CHART COLUMNS DEFAULT BACK COLOR
export const CHART_COLUMNS_BACK_COLOR = defaultSpreadSheetConfig.chartsColumnBackColor;
// STRESSES
export const STRESS_COLOR = 'Orange';
// KRIs GroupID for ungrouped
export const UNGROUPED_NAME = '[Ungrouped]';

export const ROW_HEIGHT = 22;
export const COL_WIDTH = 100;
export const ROW_HEIGHT_TITLE = 30;
export const ROW_COUNT = 10000; // TODO: Pending of making it dynamic for all results pages (Highlights, Summary & Detail)
export const CHART_HEIGHT = Math.round(18 * ROW_HEIGHT);

const defaultSpreadOptions = {
  ...(defaultSpreadSheetConfig['spreadOptions'] ? defaultSpreadSheetConfig['spreadOptions'] : {})
};
const defaultSheetOptions = {
  ...(defaultSpreadSheetConfig['sheetOptions'] ? defaultSpreadSheetConfig['sheetOptions'] : {})
};

const sheetOptions = {
  ...defaultSheetOptions,
  isProtected: true,
  scrollbarMaxAlign: true
};
const spreadOptions = {
  ...defaultSpreadOptions,
  autoFitType: GC.Spread.Sheets.AutoFitType.cell,
  scrollIgnoreHidden: true,
  scrollbarShowMax: true,
  tabStripVisible: false,
  // These control where the user can insert formulas into the cells or not
  allowUserEditFormula: false,
  enableFormulaTextbox: false,

  grayAreaBackColor: 'Background 2',
  backColor: '#ffffff'
};

export const resultsSpreadConfig = {
  ...defaultSpreadSheetConfig,
  spreadOptions,
  sheetOptions
};
